// @flow

import React from 'react';
import ReactDOM from 'react-dom';
import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';
import Root from './Root';
import TagManager from './utils/TagManagerUtils';
import Analytics from './utils/AnalyticsUtils';

import './styles/icons';
import 'lazysizes';
import 'whatwg-fetch';
import config from 'config/app.config';

if (process.env.NODE_ENV === 'production') {
  // Init Sentry
  const sentryId = `${config.version}.${config.buildId || ''}`;

  Sentry.init({
    dsn: 'https://550479a5617448d881f279c2374c964d@o303276.ingest.sentry.io/5950851',
    integrations: [new Integrations.BrowserTracing()],
    release: `registration@${sentryId}`,
    environment: config.env,
    sampleRate: 0.02,
    tracesSampleRate: 0.02,
    dist: sentryId,
  });

  config.buildId && Sentry.setTag('buildId', config.buildId);

  // Init TagManager
  if (TagManager.isAuthorized()) {
    TagManager.init();
    Analytics.init();
  }
}

const root: ?Element = document.getElementById('root');

if (root != null) {
  ReactDOM.render(<Root />, root);
}
